import React, {useContext} from 'react';
import {Controller, useWatch} from 'react-hook-form';
import {IListColumnProps} from '@src/@interfaces/components/List/IListColumnProps';
import {IOrderModel} from '@src/@interfaces/models/Order/IOrderModel';
import {FormFieldDesignContext} from '@src/contexts/FormFieldDesignContext';
import {parseDate} from '@src/helpers/dates';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {IFormFieldItemPropsContext} from '@src/@interfaces/contexts/IFormFieldItemPropsContext';
import FormErrorMessage from '@src/components/Form/FormErrorMessage';
import CountDown from '@src/components/Timer/CountDown';
import DatePicker from '@client/src/components/Fields/DatePicker';
import app from '@src/helpers/app';
import {BootstrapColors} from '@src/@types/Bootstrap';
import {IOrderProductModel} from '@src/@interfaces/models/Order/IOrderProductModel';

export function DeadlineAtField({rowIndex: index}: IListColumnProps) {
    const {
        control,
        model,
        fieldName,
        forceDisabled,
        forceReadonly
    } = useContext<IFormFieldItemPropsContext<IOrderModel> | null>(FormFieldItemPropsContext) ?? {};

    const name = `${fieldName}.${index}.deadline_at`;

    const [design] = useContext(FormFieldDesignContext);
    const deadlineAtValue = useWatch({control, name: 'deadline_at'});
    const currentDeadlineAtValue = useWatch({control, name});
    const product: IOrderProductModel | null = app('dot-accessor').get(
            model ?? {},
            `${fieldName}.${index}`
    );

    const deadlineAt = currentDeadlineAtValue ?? deadlineAtValue;
    const isCompleted = app('dot-accessor').get(
            model ?? {},
            `${fieldName}.${index}.is_completed`,
            false
    );

    let color: BootstrapColors | undefined;
    [
        product?.red_indicator_color_since ?? model?.red_indicator_color_since,
        product?.yellow_indicator_color_since ?? model?.yellow_indicator_color_since,
    ].some((since, i) => {
        const sinceDate = since ? parseDate(since) : undefined;
        if (sinceDate && +sinceDate <= Date.now()) {
            color = i ? 'warning' : 'danger';

            return true;
        }

        return false;
    });

    return <>
        <Controller
                name={name}
                control={control}
                render={({field: {onChange, onBlur, value}, fieldState: {error}}) => {
                    return <DatePicker
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            isInvalid={Boolean(error)}
                            showTimeInput={true}
                            dateFormat="Pp"
                            placeholderText={
                                deadlineAtValue ? parseDate(deadlineAtValue).format('L, LT') : undefined
                            }
                            readOnly={design.fieldsAreReadOnly || forceReadonly}
                            disabled={design.fieldsAreDisabled || forceDisabled}
                    />;
                }}
        />

        <FormErrorMessage fieldName={name}/>

        {(!isCompleted && deadlineAt) ? <CountDown
                badgeColor={color}
                expiredAt={parseDate(deadlineAt)} className="mt-1"
        /> : null}
    </>;
}
